<template>
  <div class="other-products-section">
    <div class="other-products-section__title">
      <div class="h5 semibold">
        Другие товары этой коллекции
      </div>
      <div class="other-products-section__navigation">
        <div class="--prev" @click="prevSlide"><img src="~/assets/img/svg/common/arrow-down.svg" alt=""></div>
        <div class="--next" @click="nextSlide"><img src="~/assets/img/svg/common/arrow-down.svg" alt=""></div>
      </div>
    </div>
    <div v-if="!loading" class="other-products-section__products">
      <swiper
        :modules="[Navigation]"
        :slides-per-view="2.2"
        :space-between="8"
        :breakpoints="{
          1200: {slidesPerView: 3.2},
          1024: {slidesPerView: 2.7},
          640: {slidesPerView: 4.2},
          500: {slidesPerView: 3.2},
        }"
        class="swiper swiper-initialized swiper-horizontal"
        @swiper="setMainSlider"
        @slideChange="changeActiveSlide"
      >
        <template
          v-for="(product) in products"
          :key="`product-image-${product.url}`"
        >
          <swiper-slide>
            <div class="other-product-card">
              <nuxt-link @click="sendYandexMetrikaOnRedirect" :to="product.url" class="other-product-card__image">
                <nuxt-img
                  :src="String(product.imageId)"
                  width="178"
                  height="137"
                  fit="default"
                  loading="lazy"
                  :modifiers="{'border': 'default'}"
                  :alt="`other-product-card-image-${product.imageId}`"
                />
              </nuxt-link>
              <nuxt-link @click="sendYandexMetrikaOnRedirect" :to="product.url" class="other-product-card__body">
                <div class="other-product-card__prices">
                  <div v-if="_priceOld(product)" class="--old">{{_priceOld(product)}}</div>
                  <div class="--current">{{_price(product)}}</div>
                </div>
              </nuxt-link>

              <div
                class="other-product-card__wish collection-slider-images__wish"
                :class="{'--wish': isWish(product)}"
              >
                <div @click="() => changeWish(product)"/>
              </div>
            </div>
          </swiper-slide>
        </template>
      </swiper>
    </div>
    <div v-if="loading" class="other-products-section__products --loading">
      <div class="other-product-card">
        <div class="other-product-card__image"/>
        <div class="other-product-card__body">
          <div class="other-product-card__prices">
            <div class="--old">&nbsp;</div>
            <div class="--current">&nbsp;</div>
          </div>
        </div>
      </div>
      <div class="other-product-card">
        <div class="other-product-card__image"/>
        <div class="other-product-card__body">
          <div class="other-product-card__prices">
            <div class="--old">&nbsp;</div>
            <div class="--current">&nbsp;</div>
          </div>
        </div>
      </div>
      <div class="other-product-card">
        <div class="other-product-card__image"/>
        <div class="other-product-card__body">
          <div class="other-product-card__prices">
            <div class="--old">&nbsp;</div>
            <div class="--current">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Thumbs } from 'swiper/modules';
import useSitisWish from '#sitis/composables/useSitisWish';
import {ref} from "vue";
import type {Swiper as SwiperClass} from "swiper/types";


interface IProps {
  products: any[];
  loading: boolean;
  goal?: string;
}
const props = withDefaults(defineProps<IProps>(), {
  loading: false,
  products: () => [],
});
const {
  $numberFormat,
  $ym
} = useNuxtApp();

const mainSlider: Ref<any> = ref(null);
const setMainSlider = (_mainSlider: any) => {
  mainSlider.value = _mainSlider;
};
const prevSlide = () => {
  mainSlider.value.slidePrev();
  if (typeof $ym === 'function') {
    $ym('reachGoal', 'click_other_collection_goods');
  }
}
const nextSlide = () => {
  mainSlider.value.slideNext();
}

const _price = (product: any) => {
  const price = Number.parseFloat(String(product?.price) || '');
  return `${$numberFormat(price)} ₽`;
};
const _priceOld = (product: any) => {
  const price = Number.parseFloat(String(product?.price) || '');
  const oldPrice = Number.parseFloat(String(product?.oldPrice) || '');
  if (!oldPrice || oldPrice <= price) {
    return '';
  }

  return `${$numberFormat(oldPrice)} ₽`;
};

const wishList = useSitisWish();
const isWish = (product: any) => {
  return wishList.isInWish(product?.id);
};
const changeWish = async (product: any) => {
  if (isWish(product)) {
    await wishList.removeItemFromWishList(product?.id);
  } else {
    await wishList.addToWishList({ id: product?.id });
  }
};

const activeSlide = ref(1);

const changeActiveSlide = (event: SwiperClass) => {
    activeSlide.value = (event?.realIndex || 0) + 1;
    if (typeof $ym === 'function' && props.goal) {
      $ym('reachGoal', props.goal);
    }
};
const sendYandexMetrikaOnRedirect = function () {
  if (typeof $ym === 'function') {
    $ym('reachGoal', 'click_item_you_interested')
  }
}
</script>

<style scoped lang="scss">
.other-products-section {}
.other-products-section__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  h5 {
    color: black;
  }
}
.other-products-section__navigation {
  display: flex;
  gap: 4px;

  & > * {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px; height: 28px;
    cursor: pointer;
    border-radius: 7px;
    background-color: #EBEBEB;
    &:hover {
      background-color: #E0DEDE;
    }
    &:active {
      background-color: #C3C3C3;
    }
  }
  .--prev img {
    transform: rotate(90deg);
  }
  .--next img {
    transform: rotate(-90deg);
  }
}
.other-products-section__products {
  &.--loading {
    display: flex;
    gap: 8px;
    position: relative;
    overflow: hidden;
    & > * {
      width: calc(100% / 3.2 - 5.5px);
      height: 100%;
      border: 1px solid #EBEBEB;
      border-radius: 10px;
      background-color: #EBEBEB;
      overflow: hidden;

      @media screen and (max-width: 1199px) {
        width: calc(100% / 2.7 - 5px);
        min-width: calc(100% / 2.7 - 5px);
      }
      @media screen and (max-width: 1024px) {
        width: calc(100% / 4.2 - 6px);
        min-width: calc(100% / 4.2 - 6px);
      }
      @media screen and (max-width: 640px) {
        width: calc(100% / 3.2 - 5.5px);
        min-width: calc(100% / 3.2 - 5.5px);
      }
      @media screen and (max-width: 500px) {
        width: calc(100% / 2.2 - 5.5px);
        min-width: calc(100% / 2.2 - 5.5px);
      }
    }
  }
}

.other-product-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #EBEBEB;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
}
.other-product-card__image {
  position: relative;
  overflow: hidden;
  background-color: #F4F3F1;

  img {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    object-fit: contain;
    mix-blend-mode: multiply;
  }
  &::after {
    content: "";
    float: left;
    padding: 38.53%;
  }
}
.other-product-card__body {
  padding: 12px;
  box-sizing: border-box;
}
.other-product-card__prices {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  white-space: nowrap;

  .--old {
    margin-right: 6px;
    color: #989898;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    text-decoration-line: line-through;
  }
  .--current {
    color: #000;
    font-size: 20px;
    font-weight: 600;
    line-height: 120%;
  }
}
.other-product-card__wish {
  top: 6px; right: 6px;
  & > div {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    &:after {
      background-size: 16px;
    }
  }
}

@media (max-width: 1699px) {
  .other-product-card__prices {
    .--current {
      font-size: 17px;
    }
  }
}
@media (max-width: 1359px) {
  .other-product-card__body {
    padding: 8px 10px;
  }
  .other-product-card__prices {
    .--old {
      font-size: 10px;
    }
    .--current {
      font-size: 16px;
    }
  }
}
@media (max-width: 1023px) {
  .other-products-section {
    padding: 16px 0;
  }
}
</style>
